import { IconFileBroken } from '@tabler/icons-react';

import { registerBlockPlugin } from '../../core/BlockPluginRegistry';
import type { BlockPlugin } from '../../core/types';
import { PageBreakBlockView } from './PageBreakBlockView';

export const pageBreakPlugin: BlockPlugin = {
    name: 'newPage',
    displayName: 'Page Break',
    hasData: false,
    Component: PageBreakBlockView,
    toolbarInsert: {
        icon: <IconFileBroken size={16} />,
        title: 'Page Break',
        description: 'Insert a page break',
        category: 'break'
    }
};

registerBlockPlugin(pageBreakPlugin);
